import { BillingCollectionStatus } from "../../../../../services/cloudchipr.api";

export const isBillingWarningStatus = (
  status: BillingCollectionStatus | undefined,
): boolean => {
  return status === "missing_setup";
};
